import { QueryResult } from 'react-query';
import { Controller, useApi, UseApiOptions } from './useApi';
// eslint-disable-next-line import/no-cycle
import { ArtikelEigenschaft } from './artikelEigenschaft';

export interface ArtikelEigenschaftLink {
    artikelNr: string;
    pos: number;
    eigenschaftKz: string;
    eigenschaftNr: number;
    updDat?: string;
    updUhr?: number;
    updUser?: string;

    artikelEigenschaft?: ArtikelEigenschaft;
}

export interface ArtikelEigenschaftLinkFilter {
    artikelNr?: string;
    artikelNrList?: string[];
    maxRows?: number;
}

export function useArtikelEigenschaftLinkList(
    filter: ArtikelEigenschaftLinkFilter,
    apiOptions?: UseApiOptions<ArtikelEigenschaftLink[]>,
): QueryResult<ArtikelEigenschaftLink[]> {
    return useApi<ArtikelEigenschaftLink[]>(Controller.artikelEigenschaftLink + '/list', { filter }, apiOptions);
}
